import { useCallback, useEffect, useState } from "react"
import { Button, Form } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import "./style.scss"

import * as secureAction from "../../store/secure/actions"
import { getAccessToken } from "../../store/auth/selector"
import {  getAppInfo, getGateConf } from "../../store/app/selector"
import { giftCodeClaimData } from "../../store/secure/selector";

const GiftCode = () => {
    const { t } = useTranslation('translations');

    const dispath = useDispatch();

    const appInfo = useSelector(state => getAppInfo(state))
    const access_token = useSelector(state => getAccessToken(state, appInfo))
    const gateConf = useSelector(state => getGateConf(state))

    const giftCodeResult = useSelector(state => giftCodeClaimData(state))

    const [code, setCode] = useState("")
    const [enable, setEnable] = useState(true)
    const onCodeChange = (event) => {
        setCode(event.target.value)
        setEnable(event.target.value !== "")
    }
    const onGiftcodeClaim = useCallback(() => {
        dispath(secureAction.giftCodeClaim(access_token, code, gateConf.apiUrl))
    })

    useEffect(() => {
    }, [giftCodeResult])
    return (
        <div id="giftcode">
            <Form className="form">
                <Form.Group className="input">
                    <Form.Control isValid={giftCodeResult.chip !== undefined && giftCodeResult.chip > 0} isInvalid={giftCodeResult.chip === undefined } placeholder="type giftcode here..." onChange={onCodeChange}></Form.Control>
                    {giftCodeResult.chip === undefined && <Form.Control.Feedback type="invalid">{t(giftCodeResult.erro_msg)}</Form.Control.Feedback>}
                    {giftCodeResult != undefined && giftCodeResult.chip > 0 && <Form.Control.Feedback>{t(giftCodeResult.erro_msg)}</Form.Control.Feedback>}
                </Form.Group>
                <Form.Group className="button">
                    <Button className={enable ? "" : "disable"}  type="button" onClick={() => onGiftcodeClaim()}>{t('txt14')}</Button>
                </Form.Group>
            </Form>
        </div>
    )
}

export default GiftCode